import { render, staticRenderFns } from "./Addp.vue?vue&type=template&id=fdf7aaa2&"
import script from "./Addp.vue?vue&type=script&lang=js&"
export * from "./Addp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports